module.exports = __webpack_public_path__ + "assets/img/second_user_s.eb8005c0.svg";